/* ── VYRO SLEEP — MAIN JS ── */

/* Cart Drawer */
(function() {
  const overlay = document.getElementById('cart-overlay');
  const drawer  = document.getElementById('cart-drawer');
  const trigger = document.getElementById('cart-trigger');
  const closeBtn = document.getElementById('cart-close');

  function openCart(e) {
    if (e) e.preventDefault();
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* Intercept add-to-cart forms → AJAX → open drawer */
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(r => r.json())
    .then(function() {
      return fetch('/cart.js');
    })
    .then(r => r.json())
    .then(function(cart) {
      updateCartDrawer(cart);
      openCart();
    })
    .catch(function(err) {
      console.error('Cart error:', err);
    });
  });

  function updateCartDrawer(cart) {
    /* Update count badge */
    const badge = document.querySelector('.nav-cart-count');
    if (cart.item_count > 0) {
      if (badge) {
        badge.textContent = cart.item_count;
      } else {
        const link = document.getElementById('cart-trigger');
        if (link) {
          const span = document.createElement('span');
          span.className = 'nav-cart-count';
          span.textContent = cart.item_count;
          link.appendChild(span);
        }
      }
    }

    /* Re-render cart items */
    const itemsEl = document.getElementById('cart-items');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div style="text-align:center; padding:48px 0; color:var(--text-light);">
          <p style="font-size:40px; margin-bottom:16px;">🛏️</p>
          <p style="font-size:16px;">Your cart is empty.</p>
          <a href="/collections/all" class="btn-primary" style="margin-top:24px; display:inline-block;">Shop Mattresses</a>
        </div>`;
      const footer = drawer.querySelector('.cart-drawer__footer');
      if (footer) footer.remove();
      return;
    }

    let html = '';
    cart.items.forEach(function(item) {
      html += `
        <div class="cart-item">
          <div class="cart-item__img">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          </div>
          <div style="flex:1;">
            <p class="cart-item__name">${item.product_title}</p>
            <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            <p class="cart-item__price">${formatMoney(item.final_price)}</p>
          </div>
          <a href="/cart/change?id=${item.key}&quantity=0"
             onclick="removeItem(event, '${item.key}')"
             style="color:var(--text-light); font-size:18px; padding:4px; text-decoration:none;">✕</a>
        </div>`;
    });
    itemsEl.innerHTML = html;

    /* Update or insert footer */
    let footer = drawer.querySelector('.cart-drawer__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer__footer';
      drawer.appendChild(footer);
    }
    footer.innerHTML = `
      <div class="cart-subtotal">
        <span>Subtotal</span>
        <strong>${formatMoney(cart.total_price)}</strong>
      </div>
      <p style="font-size:12px; color:var(--text-light); margin-bottom:16px; text-align:center;">
        Shipping &amp; taxes calculated at checkout
      </p>
      <a href="/checkout" class="btn-primary"
         style="width:100%; text-align:center; padding:17px; display:block; font-size:16px;">
        Checkout — ${formatMoney(cart.total_price)}
      </a>`;
  }

  window.removeItem = function(e, key) {
    e.preventDefault();
    fetch(`/cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(r => r.json())
    .then(updateCartDrawer);
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
})();

/* Smooth scroll for anchor links */
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* Scroll-reveal animation */
(function() {
  if (!window.IntersectionObserver) return;
  const style = document.createElement('style');
  style.textContent = `
    .reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.6s ease, transform 0.6s ease; }
    .reveal.visible { opacity: 1; transform: none; }
  `;
  document.head.appendChild(style);

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .review-card, .guarantee-card, .why-feature').forEach(function(el) {
    el.classList.add('reveal');
    observer.observe(el);
  });
})();

/* ── PRODUCT CARD VARIANT SWITCHER ── */
window.cardSelectVariant = function(e, btn) {
  e.preventDefault();
  var card = btn.closest('.product-card');
  if (!card) return;

  // Active state on size buttons
  card.querySelectorAll('.card-variant-btn').forEach(function(b) {
    b.style.background = 'var(--white)';
    b.style.color = 'var(--text-mid)';
    b.style.borderColor = 'var(--border)';
  });
  btn.style.background = 'var(--midnight)';
  btn.style.color = 'var(--white)';
  btn.style.borderColor = 'var(--midnight)';

  var price    = parseInt(btn.dataset.price, 10);
  var compare  = parseInt(btn.dataset.compare, 10);
  var id       = btn.dataset.variantId;
  var avail    = btn.dataset.available === 'true';

  // Format money: cents → $X,XXX.XX
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Update displayed price
  var priceEl = card.querySelector('[data-price-display]');
  if (priceEl) priceEl.textContent = fmt(price);

  // Update compare-at price
  var compareEl = card.querySelector('[data-compare-display]');
  if (compareEl) {
    if (compare && compare > price) {
      compareEl.textContent = fmt(compare);
      compareEl.style.display = 'block';
    } else {
      compareEl.style.display = 'none';
    }
  }

  // Update hidden variant id input so Add to Cart submits the right variant
  var input = card.querySelector('[data-variant-input]');
  if (input) input.value = id;

  // Update Add to Cart button availability
  var submitBtn = card.querySelector('button[type="submit"]');
  if (submitBtn) {
    if (avail) {
      submitBtn.disabled = false;
      submitBtn.style.opacity = '1';
      submitBtn.textContent = 'Add to Cart';
    } else {
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.5';
      submitBtn.textContent = 'Sold Out';
    }
  }
};

// Set initial active styles on page load for card variant buttons
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.card-variant-btn.active').forEach(function(btn) {
    btn.style.background = 'var(--midnight)';
    btn.style.color = 'var(--white)';
    btn.style.borderColor = 'var(--midnight)';
  });
});





